<template>
    <div v-show="visible">
        <el-dialog title="老师点评详情" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="850px">    
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="evaluateStatus" label="点评状态"  width="100" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateStatus == 1">
                            <span style="color:red">待点评</span>
                        </div>
                        <div v-else-if="scope.row.evaluateStatus = 2">
                            已点评
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="点评内容" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="evaluateTitle" label="评价名称"  width="100"></el-table-column>
                <el-table-column prop="evaluateScore" label="评价分值"  width="100"></el-table-column>
                <el-table-column prop="gmtCreate" label="评价时间"   width="140"></el-table-column>
                <el-table-column fixed="right" label="操作" width="60" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="showData(scope.row)" v-if="scope.row.fileCount>0"
                            type="text"
                            size="small" style="color: #387EE8;">
                            查看附件
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                    </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 查看附件弹出框 -->
        <div v-if="correctFileVisible">
            <correctFile ref="correctFile"></correctFile>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';
    import correctFile from './CorrectFile.vue';

    export default {
        data(){
            return{
                visible:false,
                loading:false,
                correctFileVisible:false,
                form:{
                    deptId:"",
                    studentTaskId:""
                },
                data:[],
                id:"",
                title:""
            }
        },
        components: {
            correctFile
        },
        created:function () {
        },
        methods:{
            init(deptId,studentTaskId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 赋值
                this.form.deptId=deptId;
                this.form.studentTaskId=studentTaskId;

                this.getData();
            },
            indexMethod(index) {
                return index+1;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.correctaskListUrl;
                let data = {
                    deptId:this.form.deptId,
                    studentTaskId:this.form.studentTaskId
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.correctaskRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            showData(row){
                this.correctFileVisible=true;
                this.$nextTick(() => { 
                    this.$refs['correctFile'].init(this.form.deptId,row.id);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/task/CorrectTask.vue